
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWireComingFrom as ObiWireComingFromElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wire-coming-from.js';
 
 
 

 
 export const ObiWireComingFrom = createComponent({
   react: React,
   tagName: 'obi-wire-coming-from',
   elementClass: ObiWireComingFromElement,
   events: {
     
   }
  });
 
 